var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.817 40",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "sureLogoTitle"
  }, "Sure Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "sureLogoTitle"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .sureBlue {fill: #174ad6;}\r\n      .sureGradient {fill: url(#linear-gradient);}\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.478,
    y1: 27.218,
    x2: 24.34,
    y2: -6.434,
    gradientTransform: "translate(0 41) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#020611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#0a1b49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#102d79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#163ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#1a46bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#1d4fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#1e53e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#1f55e7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sureBlue",
    d: "M55.776,23.812c0-1.823-.425-3.287-1.502-4.309-.85-.829-2.154-1.381-3.968-1.63l-2.437-.331c-.709-.083-1.134-.331-1.389-.58-.312-.304-.397-.663-.397-.912,0-.856.709-1.823,2.437-1.823.879,0,2.551-.083,3.827,1.16l3.118-3.039c-1.729-1.685-3.912-2.348-6.803-2.348-4.592,0-7.37,2.624-7.37,6.215,0,1.685.453,3.011,1.389,3.95.907.912,2.268,1.492,4.053,1.74l2.438.332c.652.083,1.077.276,1.332.525.283.304.397.691.397,1.16,0,1.133-.935,1.768-2.891,1.768-1.616,0-3.458-.359-4.507-1.381l-3.175,3.094c2.041,2.044,4.563,2.597,7.653,2.597,4.252,0,7.795-2.182,7.795-6.188Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sureBlue",
    d: "M73.618,22.928v-12.762h-4.96v12.652c0,1.823-1.077,2.873-2.721,2.873s-2.664-1.05-2.664-2.873v-12.652h-4.96v12.762c0,4.309,3.43,7.072,7.625,7.072s7.681-2.762,7.681-7.072Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "sureBlue",
    d: "M86.906,16.492c0,1.022-.794,1.989-2.154,1.989h-2.806v-3.978h2.806c1.361,0,2.154.967,2.154,1.989ZM92.943,29.834l-4.365-8.204c1.587-.774,3.288-2.459,3.288-5.138,0-3.232-2.409-6.326-6.888-6.326h-7.993v19.669h4.96v-7.32h1.672l3.571,7.32h5.754Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "sureBlue",
    d: "M108.817,29.834v-4.309h-8.758v-3.453h7.483v-4.309h-7.483v-3.287h8.758v-4.309h-13.719v19.669h13.719Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "sureBlue",
    d: "M30.328,4.882L6.757,28.453C.248,21.944.248,11.391,6.757,4.882c6.509-6.509,17.062-6.509,23.571,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "sureGradient",
    d: "M23.571,11.547L0,35.118c6.509,6.509,17.062,6.509,23.571,0,6.509-6.509,6.509-17.062,0-23.571Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSureLogo);
export default __webpack_public_path__ + "static/media/sure_logo.3e37bcc37ec3f8eb013301474e6df6bd.svg";
export { ForwardRef as ReactComponent };